import { ValidationContext } from "@cv-invision/cv.invision-views.ux";
import { IdNameObjectType } from "../../state/models/global-configuration-state.model";
import { LICENSE_SUBPRODUCT_LIST, MSG_FIELDS_OPTIONS } from "./product-constant";
import { FormGroup } from "@angular/forms";
import { LicensingServiceSetting } from "./product.model";

export const LICESING_SERVICE_FORM_CONFIG = {
	licensingServiceSetting: {
		enabled: {
			path: 'licensingServiceSetting.enabled',
			DataType: 'Boolean',
			DisplayText: `Enable Licensing Services`,
			Name: 'enabled',
			customClass: 'product-form-switch ms-5 mt-4',
			isRequired: function (control, jsonModelService: ValidationContext) {
				const comparedValue = jsonModelService.FindRootValue('origin');
				return jsonModelService.IsEmpty() && comparedValue === MSG_FIELDS_OPTIONS.CLASSORDERENTRY || false;
			},
			Visible: function (control, jsonModelService: ValidationContext) {
				const comparedValue = jsonModelService.FindRootValue('origin');
				return comparedValue === MSG_FIELDS_OPTIONS.CLASSORDERENTRY || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.checked;
					if (value) {
						const licensingServiceSettings = new LicensingServiceSetting();
						formGroup.get('licensingServiceSetting').setValue({
							...licensingServiceSettings,
							enabled: value
						}, {emitEvent: false})
					}

					formGroup.get('licensingServiceSetting').updateValueAndValidity();
				},
			},
		},
		acuityCreationSetting: {
			'acuityProductId': {
				DataType: 'Selector',
				path: 'licensingServiceSetting.acuityCreationSetting.acuityProductId',
				UIControl: 'Dropdown',
				DisplayText: 'Acuity Product Name',
				label: 'Acuity Product Name',
				Name: 'acuityProductId',
				customClass: 'product-form-dropdown',
				options: [],
				UIOptions: {
					ShowClearButton: true,
					ShowFilter: true,
					showLabel: true,
				},
				isRequired: function (control, jsonModelService: ValidationContext) {
					//const comparedValue = jsonModelService.FindRootValue('licensingServiceSetting.enabled');
					return jsonModelService.IsEmpty() && jsonModelService.FindRootValue('licensingServiceSetting.enabled');
				},
				Visible: function (control, jsonModelService: ValidationContext) {
					return jsonModelService.FindRootValue('licensingServiceSetting.enabled');
				},
				UIEvents: {
					onChange: ($event: any, model: any, formGroup: any, formConfigModel: any) => {
						const value = $event.value;
						if (value !== '' && value !== null && value !== undefined) {
							const indexSelectedOption = formConfigModel.options.findIndex(element => element.value === value);
							const selectedOption = formConfigModel.options[indexSelectedOption];
							formGroup.get('licensingServiceSetting.acuityCreationSetting.acuityProductName')?.setValue(selectedOption.label);
						} else {
							formGroup.get('licensingServiceSetting.acuityCreationSetting.acuityProductId')?.setValue(null);
							formGroup.get('licensingServiceSetting.acuityCreationSetting.acuityProductName')?.setValue(null);
						}
					},
				},
			},
			'acuityProductName': {
				DataType: 'String',
				path: 'licensingServiceSetting.acuityCreationSetting.acuityProductName',
				DisplayText: '',
				label: '',
				Name: 'acuityProductName',
				required: false,
				hidden: true,
			},
		},
		subProductConfiguration: {
			products: {
				DataType: 'Array',
				path: 'subProductConfiguration.products',
				DisplayText: 'SubProduct Configuration',
				Visible: function (control, jsonModelService: ValidationContext) {
					return jsonModelService.FindRootValue('licensingServiceSetting.enabled');
				},
				child: [
					{
						name: {
							DataType: 'Number',
							DisplayText: '',
							Name: 'name',
							hidden: true,
							required: false
						},
						id: {
							DataType: 'Selector',
							UIControl: 'Dropdown',
							DisplayText: 'SubProduct Configuration Name',
							label: 'SubProduct Configuration Name',
							Name: 'id',
							options: [],
							UIOptions: {
								ShowClearButton: true,
								showLabel: true
							},
							required:false,
							Visible: function (control, jsonModelService: ValidationContext) {
								const comparedValue = jsonModelService.FindRootValue('licensingServiceSetting.enabled');
								return comparedValue || false;
							},
							UIEvents: {
								onChange: (
									$event: any,
									model: any,
									formGroup: any,
									formFieldConfig: any
								) => {

									const value = $event.value;
									const formArray = formGroup?.get('licensingServiceSetting.subProductConfiguration.products');

									if (value) {
										const indexOptionSelected = formFieldConfig.options.findIndex(element => element.value === value);

										if (indexOptionSelected >= 0) {
											formArray.at(0).get('name')?.setValue(formFieldConfig.options[indexOptionSelected].label);
										}
									} else {
										formArray.at(0).get('name')?.setValue(null);
									}
								},
							},
						},
						creationTrigger: {
							DataType: 'Selector',
							UIControl: 'Dropdown',
							DisplayText: 'Creation Trigger',
							label: 'Creation Trigger',
							Name: 'creationTrigger',
							required:false,
							options: LICENSE_SUBPRODUCT_LIST.map((item: IdNameObjectType) => {
								return {
									label: item.name,
									value: item.id,
								};
							}),
							Visible: function (control, jsonModelService: ValidationContext) {
								const comparedValue = jsonModelService.FindRootValue('licensingServiceSetting.enabled');
								return comparedValue || false;
							},
							UIOptions: {
								ShowClearButton: true,
								showLabel: true
							}
						}
					},
					{
						name: {
							DataType: 'Number',
							DisplayText: 'Fee Sidecar 1 ',
							Name: 'name',
							hidden: true,
							required: false,
						},
						id: {
							DataType: 'Selector',
							UIControl: 'Dropdown',
							DisplayText: 'SubProduct Configuration Name',
							label: 'SubProduct Configuration Name',
							Name: 'id',
							options: [],
							UIOptions: {
								ShowClearButton: true,
								showLabel: true
							},
							Visible: function (control, jsonModelService: ValidationContext) {
								const comparedValue = jsonModelService.FindRootValue('licensingServiceSetting.enabled');
								return comparedValue || false;
							},
							UIEvents: {
								onChange: (
									$event: any,
									model: any,
									formGroup: any,
									formFieldConfig: any
								) => {

									const value = $event.value;
									const formArray = formGroup?.get('licensingServiceSetting.subProductConfiguration.products');

									if (value) {
										const indexOptionSelected = formFieldConfig.options.findIndex(element => element.value === value);

										if (indexOptionSelected >= 0) {
											formArray.at(1).get('name')?.setValue(formFieldConfig.options[indexOptionSelected].label);
										}
									} else {
										formArray.at(1).get('name')?.setValue(null);
									}
								},
							},
						},
						creationTrigger: {
							DataType: 'Selector',
							UIControl: 'Dropdown',
							DisplayText: 'Creation Trigger',
							label: 'Creation Trigger',
							Name: 'creationTrigger',
							options: LICENSE_SUBPRODUCT_LIST.map((item: IdNameObjectType) => {
								return {
									label: item.name,
									value: item.id,
								};
							}),
							Visible: function (control, jsonModelService: ValidationContext) {
								const comparedValue = jsonModelService.FindRootValue('licensingServiceSetting.enabled');
								return comparedValue || false;
							},
							UIOptions: {
								ShowClearButton: true,
								showLabel: true
							}
						}
					}],
				childFormBuilderConfig: {},
			},
		}

	},

};
